import {
  SAVE_ARTICLE,
  SAVE_ARTICLE_SUCCESS,
  SAVE_ARTICLE_FAILURE
} from './actionTypes';

const initialState = {
  isSaving: false,
  article: {},
  error: []
};

export const newArticleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_ARTICLE:
      return { ...state, isSaving: true };
    case SAVE_ARTICLE_SUCCESS:
      return { ...state, isSaving: false, article: action.payload };
    case SAVE_ARTICLE_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};

export const isSaving = state => state.newArticle.isSaving;
export const getArticle = state => state.newArticle.article;
export const getError = state => state.newArticle.error;



// WEBPACK FOOTER //
// ./src/modules/ArticleForm/reducer.js